module.exports = __webpack_public_path__ + "static/media/user-avatar-filled.0345e84f.svg";